"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetPasswordForm = ResetPasswordForm;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("react");
var react_router_dom_1 = require("react-router-dom");
var routes_1 = require("../../constants/routes");
var auth_1 = require("../../features/apis/auth");
var api_error_message_1 = require("../../utils/api-error-message");
var button_component_1 = require("../ui/button-component");
var text_component_1 = require("../ui/text-component");
function ResetPasswordForm() {
    var _this = this;
    var _a;
    var minimumPasswordLength = 6;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var searchParams = (0, react_router_dom_1.useSearchParams)()[0];
    /** The emailed link carries the Firebase reset code, so the user never types it in. */
    var resetCode = (_a = searchParams.get("oobCode")) !== null && _a !== void 0 ? _a : "";
    var initialFormState = {
        password: "",
        confirmPassword: "",
    };
    var _b = (0, react_2.useState)(initialFormState), form = _b[0], setForm = _b[1];
    var _c = (0, react_2.useState)({}), errors = _c[0], setErrors = _c[1];
    var _d = (0, react_2.useState)(""), formError = _d[0], setFormError = _d[1];
    var _e = (0, auth_1.useConfirmForgotPasswordMutation)(), confirmForgotPassword = _e[0], isConfirming = _e[1].isLoading;
    var validate = function () {
        var nextErrors = {};
        if (!form.password)
            nextErrors.password = "New password is required";
        if (form.password && form.password.length < minimumPasswordLength) {
            nextErrors.password = "Password must be at least ".concat(minimumPasswordLength, " characters");
        }
        if (form.password && form.confirmPassword !== form.password)
            nextErrors.confirmPassword = "Passwords do not match";
        setErrors(nextErrors);
        return Object.keys(nextErrors).length === 0;
    };
    var handleSubmit = function () { return __awaiter(_this, void 0, void 0, function () {
        var response, requestError_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setFormError("");
                    if (!validate())
                        return [2 /*return*/];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, confirmForgotPassword({ code: resetCode, password: form.password }).unwrap()];
                case 2:
                    response = _b.sent();
                    if (!response.success) {
                        setFormError((_a = response.message) !== null && _a !== void 0 ? _a : "Unable to reset your password. Please request a new link and try again.");
                        return [2 /*return*/];
                    }
                    navigate(routes_1.ROUTES.LOGIN);
                    return [3 /*break*/, 4];
                case 3:
                    requestError_1 = _b.sent();
                    setFormError((0, api_error_message_1.getApiErrorMessage)(requestError_1, "Something went wrong while resetting your password. Please try again."));
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    if (!resetCode) {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "flex w-full flex-col gap-4", children: [(0, jsx_runtime_1.jsx)("div", { role: "alert", children: (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "red-600", label: "This password reset link is missing its code. Please request a new one." }) }), (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: routes_1.ROUTES.FORGOT_PASSWORD, className: "text-sm font-semibold text-primary-navy hover:underline", children: "Request a new link" })] }));
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex w-full flex-col gap-4", children: [(0, jsx_runtime_1.jsxs)(react_1.TextField, { type: "password", value: form.password, onChange: function (value) { return setForm(function (prev) { return (__assign(__assign({}, prev), { password: value })); }); }, isInvalid: !!errors.password, fullWidth: true, children: [(0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "xsmall", weight: "medium", color: "dark-gray-1", label: "New Password" }), (0, jsx_runtime_1.jsx)(react_1.Input, { placeholder: "New password", className: "auth-field rounded-md border-gray-300 shadow-sm" }), errors.password && ((0, jsx_runtime_1.jsx)("div", { role: "alert", children: (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "red-600", label: errors.password }) }))] }), (0, jsx_runtime_1.jsxs)(react_1.TextField, { type: "password", value: form.confirmPassword, onChange: function (value) { return setForm(function (prev) { return (__assign(__assign({}, prev), { confirmPassword: value })); }); }, isInvalid: !!errors.confirmPassword, fullWidth: true, children: [(0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "xsmall", weight: "medium", color: "dark-gray-1", label: "Confirm New Password" }), (0, jsx_runtime_1.jsx)(react_1.Input, { placeholder: "Confirm new password", className: "auth-field rounded-md border-gray-300 shadow-sm" }), errors.confirmPassword && ((0, jsx_runtime_1.jsx)("div", { role: "alert", children: (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "red-600", label: errors.confirmPassword }) }))] }), formError && ((0, jsx_runtime_1.jsx)("div", { role: "alert", children: (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "red-600", label: formError }) })), (0, jsx_runtime_1.jsx)(button_component_1.ButtonComponent, { label: "Reset Password", onPress: handleSubmit, isPending: isConfirming, color: "white", backgroundColor: "primary-navy", hoverColor: "primary-navy-light", className: "w-full py-2.5" }), (0, jsx_runtime_1.jsxs)("p", { className: "text-sm text-medium-gray", children: ["Link expired?", " ", (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: routes_1.ROUTES.FORGOT_PASSWORD, className: "font-semibold text-primary-navy hover:underline", children: "Request a new one" })] })] }));
}
